(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('packageService', [function () {
            var packageService = {};
            const tieredPackages = ['Starter Package', 'Pro Package', 'Premium Package'];

            packageService.isTieredPackage = function (packageName) {
                return tieredPackages.includes(packageName);
            };

            return packageService;
        }]);
}());
